import _ from 'underscore';
import { IContentInfo } from '../models/IContentInfo';
import { IContent,  ExploreContentApi_ContentType } from '../ServerApi/types/IContent';
import { IUser } from '../ServerApi/types/IUser';
import { MapperHelper } from './MapperHelper';
import { UserMapper } from './UserMapper';
import { appendDraftIdPrefix } from '../../drafts/utils/DraftUtils';
import { INamedItemInfo, ITypedItemInfo } from '../models/resourceInfoParts';
import { FeatureFlags } from '../FeatureFlags';
import { ILocationInfo, LocationTypes } from '../models/ILocationInfo';

export namespace ContentMapper {

  export function map(content: IContent[], users: _.Dictionary<IUser>): IContentInfo[] {

    return _.map(content, (c: IContent): IContentInfo<typeof c.contentType> => {
      return {
        // Explore API returns a number for id which can cause equaliy mismatches with getProjects/etc APIs
        // So cast id to a string here so it will match all existing APIs
        id: c.id ? '' + c.id : appendDraftIdPrefix(c.draftId), // drafts with 'unpublished' status don't have an id so map to draftId with prefix for uniqueness
        luid: c.luid || null,
        // TODO: Remove this hack after TFSID 963146 is resolved
        contentType: c.contentType.toString() === 'datarole' ? 'dataRole' : c.contentType,
        name: c.name,
        description: c.description,
        owner: UserMapper.mapOne(users[c.ownerId]),
        createdAt: MapperHelper.toDate(c.createdAt),
        updatedAt: MapperHelper.toDate(c.updatedAt),
        favorite: c.isFavorite,
        favoritesTotal: c.favoritesTotal,
        thumbnailUrl: c.thumbnailUrl,
        tags: c.tags || [],
        contentDetail: tryParseJson(c.contentDetail),
        draftLuid: c.draftLuid ? c.draftLuid : null,
        draftId: c.draftId ? c.draftId : null,
        draftStatus: c.draftStatus ? c.draftStatus : null,
        extractDraftAvailable: c.extractDraftAvailable
      };
    });
  }

  function tryParseJson(jsonString: string): any{
    if(!jsonString){
      return null;
    }

    try {
      return JSON.parse(jsonString);
    } catch (e) {
      return null;
    }
  }

  export const ContentTypeToTargetMap: Record<ExploreContentApi_ContentType, string> = {
    project: 'PROJECT',
    workbook: 'WORKBOOK',
    datasource: 'DATASOURCE',
    dataRole: 'DATAROLE',
    lens: 'LENS',
    view: 'VIEW',
    dataconnection: '',
    flow: 'FLOW',
    databaseWithCrass: '',
    tableWithCrass: '',
    database: '',
    table: '',
    metric: 'METRIC',
    publishedConnection: 'PUBLISHED_CONNECTION',
    collection: 'COLLECTION'
  };

  export function getContentToProjectMap(contentType: string, projects: _.Dictionary<INamedItemInfo>) {
    const contentToProject: _.Dictionary<INamedItemInfo> = {};
    if (!FeatureFlags.refactorProjectEnabled) {
      return contentToProject;
    }
    _.forEach(projects, (project) => {
      _.forEach(project.contents[contentType], (content: number) => {
        contentToProject[content] = project;
      });
    });
    return contentToProject;
  }

  export function getContentToLocationMap(contentType: string, locations: ILocationInfo[]) {
    const contentToLocation: _.Dictionary<ILocationInfo> = {};
    if (!FeatureFlags.personalSpaceEnabled) {
      return contentToLocation;
    }
    _.forEach(locations, (location) => {
      if (location.contents) {
        _.forEach(location.contents[contentType], (content: number) => {
          contentToLocation[content] = location;
        });
      }
    });
    return contentToLocation;
  }

}
